'use es6';

import { formatPathAsId } from 'DesignData/lib/text';
export const ROOT_FOLDER_ID = 'root';
/*
 * @hubspot folder data
 */

export const HUBSPOT_FOLDER_PATH = '@hubspot';
export const HUBSPOT_FOLDER_NAME = '@hubspot';
export const HUBSPOT_FOLDER_ID = formatPathAsId(HUBSPOT_FOLDER_PATH);
/*
 * @marketplace folder data
 */

export const MARKETPLACE_FOLDER_PATH = '@marketplace';
export const MARKETPLACE_FOLDER_NAME = '@marketplace';
export const MARKETPLACE_FOLDER_ID = formatPathAsId(MARKETPLACE_FOLDER_PATH);
export const PRETTIFIED_FOLDER_NAMES = {
  [HUBSPOT_FOLDER_NAME]: 'HubSpot',
  [MARKETPLACE_FOLDER_NAME]: 'Marketplace'
};